import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgDialogModule } from '@principle-theorem/ng-shared';
import {
  FundingRequestStatus,
  IAccClaimFundingRequest,
} from '@principle-theorem/principle-core/interfaces';
import { WithRef } from '@principle-theorem/shared';
import { AccClaimDetailsDisplayComponent } from '../acc-claim-details-display/acc-claim-details-display.component';

export interface IAccViewClaimDialogData {
  claimRequest: WithRef<IAccClaimFundingRequest>;
}

export const FUNDING_REQUEST_STATUS_CLASS_MAP: Record<
  FundingRequestStatus,
  string
> = {
  [FundingRequestStatus.Approved]: 'bg-success-50 text-success-700',
  [FundingRequestStatus.Pending]: 'bg-primary-50 text-primary-700',
  [FundingRequestStatus.Submitted]: 'bg-primary-50 text-primary-700',
  [FundingRequestStatus.Failed]: 'bg-warn-50 text-warn-700',
  [FundingRequestStatus.Cancelled]: 'bg-warn-50 text-warn-700',
  [FundingRequestStatus.Declined]: 'bg-warn-50 text-warn-700',
  [FundingRequestStatus.Draft]: 'bg-gray-50 text-default-700',
  [FundingRequestStatus.Paid]: 'bg-success-50 text-success-700',
  [FundingRequestStatus.PartiallyPaid]: 'bg-success-50 text-success-700',
  [FundingRequestStatus.Redeemed]: 'bg-success-50 text-success-700',
};

@Component({
  selector: 'pr-acc-view-claim-dialog',
  imports: [NgDialogModule, AccClaimDetailsDisplayComponent],
  templateUrl: './acc-view-claim-dialog.component.html',
  styleUrl: './acc-view-claim-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccViewClaimDialogComponent {
  data = inject<IAccViewClaimDialogData>(MAT_DIALOG_DATA);

  get statusClasses(): string {
    return FUNDING_REQUEST_STATUS_CLASS_MAP[this.data.claimRequest.status];
  }
}
